import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { useSession } from '@sdk/session/SessionContext';
import parseMarkdownToHtml from '@sdk/components/richText/helpers/parseMarkdownToHtml';
import { Config, MarkdownParser } from '@sdk/components/richText/helpers/parseMarkdownToHtml.types';

import { highlightSearchResult } from '@web/common/utils/highlightSearchResult';

/**
 * Alternative to adding custom parser was to allow our `parseMarkdownToHtml`
 * to accept additional plugin list, but since order of plugins matters
 * it's more flexible to replace whole parser.
 */
export const useParsedContent = (
  content: string,
  searchQuery: string | null,
  customParser?: MarkdownParser
) => {
  const { personasDict } = usePersonaCollection();
  const { currentUser } = useSession();

  const parsedContent = useMemo(() => {
    const config: Config = {
      currentUser,
      personasDict,
      parseMentions: true,
      disableRedirects: !!searchQuery,
    };
    const parsedContent = customParser
      ? customParser(content, config)
      : parseMarkdownToHtml(content, config);

    let html = parsedContent;
    if (searchQuery) {
      html = highlightSearchResult(parsedContent, searchQuery);
    }

    return {
      __html: html,
    };
  }, [currentUser, content, personasDict, searchQuery, customParser]);

  return parsedContent;
};
